import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../assets/CSS/post.css"; 
import Post from "../components/Post"; 

function Feed() { 
  const [posts, setPosts] = useState([]); // State for posts
  const [caption, setCaption] = useState(""); // State for post caption
  const [imageFile, setImageFile] = useState(null); // State for image file
  const fileInputRef = useRef(null); // For å nullstille fil-input etter opplasting

  const storedUser = localStorage.getItem("loggedInUser"); // Hent innlogget bruker fra localStorage
  const userId = storedUser ? JSON.parse(storedUser).id : null; 

  useEffect(() => { // Hent posts når komponenten lastes
    if (!userId) return; // Hvis ingen bruker er logget inn, gjør ingenting (skal ikke kunne skje)
    fetchPosts();
  }, []);

  const fetchPosts = async () => { // Funksjon for å hente posts fra serveren
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/posts/details`); // Endepunkt for å hente alle posts
      setPosts(response.data);  // Oppdater posts state med data fra serveren
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  const handlePostSubmit = async () => { 
  if (!caption.trim() && !imageFile) return; //Hvis det ikke er en caption eller et bilde i det hele tatt

  const MAX_FILE_SIZE = 5; //Setter max størrelse sånn at det funker på windows i tillegg endelig

  if (imageFile && imageFile.size > MAX_FILE_SIZE * 1024 * 1024) { // Hvis bildet er for stort
    alert(`File is too big! Max size is ${MAX_FILE_SIZE}MB`); //ALERT
    return; // og ikke gjør noe mere etter det
  }

  try {
    let imageId = null; //Nullstille

    if (imageFile) {  
      const formData = new FormData();
      formData.append("file", imageFile);

      const imageUploadRes = await axios.post(
        `${process.env.REACT_APP_API_URL}/images/upload?profileId=${userId}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      imageId = imageUploadRes.data.id;
    }

    await axios.post(`${process.env.REACT_APP_API_URL}/posts`, {
      caption: caption.trim(),
      date: new Date().toISOString(),
      userId: userId,
      imageId: imageId,
    });

    setCaption("");
    setImageFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }

    fetchPosts();
  } catch (err) {
    console.error("Uploading error:", err);

    if (err.response && err.response.status === 413) { 
      alert("File too big, must be under 5MB ");
    } else if (err.response && err.response.status === 400) {
          const data = err.response.data;
      alert("Caption must be under 300 characters.");
    } else {
      alert("Something went wrong during the upload. Please try again later.");
    }
  }
};


  // Render komponenten i Feed
  // Inkluderer en boks for å lage nye innlegg
  // Viser også listen over posts ved å bruke Post-komponenten
  return (
    <div className="feed-container">
      <div className="create-post">
        <h3>Post something here</h3>
        <textarea
          placeholder="Post a Zing..."
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
<div className="post-actions">
  <div style={{ display: 'inline-flex', alignItems: 'center' }}>
    <input
      type="file"
      accept="image/*"
      onChange={(e) => setImageFile(e.target.files[0])}
      ref={fileInputRef}
    />
  </div>

  <button className="post-btn" onClick={handlePostSubmit}>
    Post
  </button>

</div>
      </div>
      <Post posts={posts} fetchPosts={fetchPosts} />
    </div>
  );
}

export default Feed;